import { useQuery } from 'react-query';
import * as config from "../../../app.config";
import { setHeaders } from "../../../utils/basic";
import axios from "axios";

const getQCMetrics = async (plateId) => {
    const headerConfig = setHeaders();

    const { data } = await axios.get(`${config.ENDPOINTS["datalake"]}/display/qc_metrics/${plateId.queryKey[1]}`,
        {
            headers: headerConfig
        });

    return data;
}

export default function useFetchQCMetrics(plateId) {
    return useQuery(['QCMetrics', plateId], getQCMetrics, {
        //  enabled: Boolean(plateId),
        onSuccess: (data) => {
            //  console.log(data)

        },
        onError: (error) => {
            console.log(error);
        }
    });
}